import React from 'react'

import { Skeleton } from '@mui/material'
import { useCustomerContactsPhoneQuota } from 'features/customers/hooks/useCustomerContactsPhoneQuota'

import QuotaUsage from 'components/_base/QuotaUsage'

import UsageUnavailable from './UsageUnavailable'

const CustomerContactsPhoneUsage = () => {
  const { data: quota, isPending, isError } = useCustomerContactsPhoneQuota()

  if (isPending) {
    return <Skeleton variant="text" width={85} />
  }

  if (isError) {
    return <UsageUnavailable />
  }

  return <QuotaUsage quota={quota?.total} usage={quota?.used} />
}

export default CustomerContactsPhoneUsage
